import { useEffect, useState } from 'react'
import { Button, Stack, TableCell, TableRow, useTheme } from '@mui/material'
import { Box, Typography } from '@mui/material'
import { Item } from '../../../common/snippets'
import * as mdt from '../../../common/modaltypes'
import * as id from '../reportId'
import AppsIcon from '@mui/icons-material/Apps'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import { focusElemnt, navigation3 } from '../../../common/helper'

import { useAtom } from 'jotai'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { exportToExcel } from '../../../common/hook'
import { makeTable } from '../analysisReport/pdfAutotable'
import { divideInNIntegers } from '../../../common/mathHelper'
import { modalAtom } from '../../../common/jotaiState/globalStateAtoms'
import useToken from '../../../helpers/useTokens'
import { branchSummaryData, cityWiseGroup, paymentSummaryData, statusWiseSummaryData } from './utilFucntions'
import VirtualizedTable from '../../../common/virtualisedTable'
import {
  calculateDynamicFormatLandscape,
  calculateDynamicFormatPortrait,
  calculateTotalTableWidth,
  nonMovementFilter,
  statusWiseSummary,
} from './NonMovementConstant'
var totalPagesExp = '{total_pages_count_string}'

export const ReportTable = ({ tableData, tableData2, columnDefs, filterData, viewId, optionId }) => {
  const theme = useTheme()
  const { tableHeaderColor } = theme
  const { loginData } = useToken()
  const [, setModal] = useAtom(modalAtom)
  const [roleRights] = useAtom(CargoRoleRightsAtom)
  const RoleRights = roleRights?.Table1?.[0] || {}
  const { AllowExportExcel = 0 } = RoleRights
  const [showTableData, setShowTableData] = useState([])
  const [searchResult, setSearchResult] = useState(true)
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const isBranchWise = filterData.IncludeDate || false
  const { generatePDF, load } = { ...state }
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')
  const span1 = divideInNIntegers(columnDefs.length, 2)
  const excelHeader1 = nonMovementFilter.map((item) => ({ header: item.header, field: item.dataKey }))
  const excelHeader2 = columnDefs.flatMap((col) => {
    if (typeof col.field === 'string' && col.field.includes('^^')) {
      const [field1, field2] = col.field.split('^^')
      const [header1, header2] = (col.exportHead || '').split('\n')
      return [
        { field: field1, header: header1, align: col.textAlign },
        { field: field2, header: header2, align: col.textAlign },
      ]
    }
    return { field: col.field, header: col.exportHead, align: col.textAlign }
  })
  const header1 = [
    [
      { header: `Report For: ${filterData.reportOption} Report`, field: '', span: span1[0], mainHeader: true },
      { header: `Company Name : ${loginData.strCompanyName}`, field: '', span: span1[1] },
    ],
  ]
  useEffect(() => {
    if (tableData?.length > 0) {
      if (viewId === 1) {
        let data = cityWiseGroup(tableData, tableData2, columnDefs, filterData)
        setShowTableData(data)
      } else {
        if (optionId === 1) {
          let data = paymentSummaryData(tableData, columnDefs, filterData)
          setShowTableData(data)
        }
        if (optionId === 2) {
          setShowTableData(branchSummaryData(tableData, columnDefs, filterData))
        }
        if (optionId === 3) {
          setShowTableData(statusWiseSummaryData(tableData, columnDefs, filterData, statusWiseSummary))
        }
      }
    } else {
      setShowTableData([])
    }
  }, [tableData])

  const customFunction = (data, doc) => {
    doc.setTextColor(0, 0, 0)
    doc.setFontSize(18).setFont('Roboto', 'bold')
    doc.text(
      `Collection Date: ${filterData.IncludeDate ? `${filterData.FromDate} to ${filterData.ToDate}` : filterData.financialYear}`,
      data.settings.margin.left,
      150
    )
    doc.text(`Report View: ${filterData.reportOption}`, doc.internal.pageSize.width - data.settings.margin.left, 150, 'right')
  }
  const customFunction2 = (data, doc) => {
    doc.setTextColor(40)
    doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
    doc.setFontSize(26).setFont('Roboto', 'bold')
    doc.setTextColor(16, 79, 162)
    doc.text(`Cargo System | ${filterData.reportOption} Report`, 30 + 60, 80)
    doc.setTextColor(0, 0, 0)
    doc.setFontSize(22).setFont('Roboto', 'bold')
    doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
    jsPdfHeaderFooter(data, loginData, totalPagesExp)
  }
  const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
    const doc = data.doc
    // Footer
    var pageSize = doc.internal.pageSize
    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

    var str = 'Page : ' + doc.internal.getNumberOfPages()
    if (typeof doc.putTotalPages === 'function') {
      str = str + ' of ' + totalPagesExp
    }
    doc.setFontSize(16)
    doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, 'right')
    doc.setFont('Roboto', 'bold')
    doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
    doc.text(
      `Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`,
      doc.internal.pageSize.width / 2 -
      (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) / 2 +
      90,
      pageHeight - 5
    )
  }
  const printClick = (isSave) => {
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const pdfColumns = columnDefs.map((col) => {
      return { header: col?.header, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfData = showTableData.map((col) => ({ ...col, 'LastStatus^^DaysInterval': col.LastStatus + '\n' + col.DaysInterval }))
    const orientation = viewId === 1 ? 'l' : 'p'
    const dimensions = viewId === 1 ? [1560, 1103] : [1240, 1754]
    const doc = new jsPDF({
      orientation: orientation,
      format: dimensions,
      unit: 'px',
      compress: true,
    })

    doc.setProperties({
      title: `${filterData.reportOption}.pdf`,
      subject: `${filterData.reportOption} Report`,
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    makeTable(doc, autoTable, nonMovementFilter, [filterData], 1, filterData.reportOption, loginData, 'everyPage', customFunction, 170)
    makeTable(
      doc,
      autoTable,
      pdfColumns,
      pdfData,
      1,
      filterData.reportOption,
      loginData,
      optionId === 3 ? 'never' : 'everyPage',
      customFunction2
    )

    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`${filterData.reportOption} Report ${currentDateTime}.pdf`)
    }
    setTimeout(() => {
      setState({ ...state, generatePDF: false, load: true })
      const pdfUrl = doc.output('bloburl')
      document.getElementById('userWiseCollectionoutput').data = pdfUrl
      // document.getElementById('userWiseCollectionoutput').data = doc.output('datauristring', `${filterData.reportOption}.pdf`)
      focusElemnt('UWBackBtn')
    }, 2000)
  }
  const headerContent = () => {
    if (optionId === 3) {
      return <></>
    }
    return (
      <TableRow style={{ height: '47px' }}>
        {columnDefs.map((item) => {
          const align = item.align || 'left'
          return (
            <TableCell
              style={{
                backgroundColor: '#e5f3ff',
                color: '#444',
                fontSize: '12px',
                lineheight: '16px',
                letterspacing: '0.24px',
                fontWeight: '600',
                whiteSpace: 'pre-line',
                padding: '10px 4px',
                textAlign: align,
              }}
              colSpan={1}
            >
              {item?.header}
            </TableCell>
          )
        })}
      </TableRow>
    )
  }
  const DisPatchBody = ({ row, index, tableHeaderColor, columnDefs }) => {
    if (!row?.dataType) return null
    const getStyles = (field, align) => {
      const common = {
        minHeight: '36px',
        fontSize: '12px',
        color: '#444',
        padding: '10px 4px',
        whiteSpace: 'pre',
      }
      if (row.dataType === 'header') {
        return {
          ...common,
          fontWeight: '700',
          backgroundColor: tableHeaderColor?.isHeadingColor,
          textAlign: row.align?.[field] || align,
        }
      }
      if (row.dataType === 'entry') {
        return {
          ...common,
          fontWeight: '600',
          textAlign: align || 'left',
          height: '36px',
        }
      }
      if (row.dataType === 'subHeader') {
        return {
          ...common,
          fontWeight: '700',
          backgroundColor: tableHeaderColor?.isSubHeadingColor,
          textAlign: row.align?.[field] || 'left',
        }
      }
      if (row.dataType === 'total') {
        return {
          ...common,
          fontWeight: '700',
          backgroundColor: tableHeaderColor?.isTotalColor,
          textAlign: row.align?.[field] || 'right',
        }
      }
    }

    return (
      <>
        {(() => {
          let skip = 0

          return columnDefs.map((item, i) => {
            if (skip > 0) {
              skip--
              return null
            }
            const colSpan = row.colSpan?.[item.field] || 1
            skip = colSpan - 1
            return (
              <TableCell className="reportTD" key={item.field + i + index} colSpan={colSpan} style={getStyles(item.field, item.align)}>
                {row[item.field]}
              </TableCell>
            )
          })
        })()}
      </>
    )
  }
  const bodyContent = (index, obj) => {
    return <DisPatchBody row={obj} index={index} tableHeaderColor={tableHeaderColor} columnDefs={columnDefs} />
  }
  return (
    <>
      <Stack style={{ margin: '0px 10px', marginRight: '0px' }}>
        <Item className="userReport">
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="h5" display="block" sx={{ fontWeight: 600, color: '#444' }}>
              Report For: Non Movement Report - {filterData.reportOption}
            </Typography>
            <Box
              sx={{
                minHeight: '32px',
                display: 'flex',
                padding: '8px 12px',
                justifycontent: 'center',
                alignitems: 'center',
                gap: '6px',
                marginX: '10px',
                fontSize: '14px',
              }}
              id="dispatchReportManageColumn"
              tabIndex={0}
              onClick={() => setModal(mdt.LRWiseDetailsReport)}
            >
              <span tabIndex={0} style={{ display: 'flex', margin: '-3px' }}>
                <AppsIcon />
              </span>
              <span tabIndex={0} style={{ fontWeight: '600' }}>
                MANAGE COLUMNS
              </span>
            </Box>
          </Box>
          <Item className="userReport-buttons">
            {searchResult ? (
              <>
                <Box>
                  <Button
                    variant="outlined"
                    className="userWisereporttembtn"
                    disabled={!AllowExportExcel}
                    onClick={() =>
                      exportToExcel({
                        fileName: `${filterData.reportOption} ${currentDateTime}.xlsx`,
                        sheetName: filterData.reportOption,
                        headersList: [header1, excelHeader1, excelHeader2],
                        dataList: [[], [filterData], showTableData],
                      })
                    }
                  >
                    Export to Excel
                  </Button>
                </Box>

                <Box>
                  <Button
                    id="UWExpToPdfBtn"
                    variant="outlined"
                    className="userWisereporttembtn"
                    onClick={() => {
                      setSearchResult(false)
                      printClick(true)
                    }}
                    onKeyDown={(e) =>
                      navigation3(e, 'UWPrintPdfBtn', !AllowExportExcel ? 'UWSplitButton' : 'UWExpToExsl', () => {
                        setSearchResult(false)
                        printClick(true)
                      })
                    }
                  >
                    Export to Pdf
                  </Button>
                </Box>
                <Box>
                  <Button
                    id="UWPrintPdfBtn"
                    variant="outlined"
                    className="userWisereporttembtn"
                    onClick={() => {
                      setSearchResult(false)
                      printClick(false)
                    }}
                    onKeyDown={(e) =>
                      navigation3(e, 'UWFromDate', 'UWExpToPdfBtn', () => {
                        setSearchResult(false)
                        printClick(false)
                      })
                    }
                  >
                    Print
                  </Button>
                </Box>
              </>
            ) : (
              <>
                <Box>
                  <Button
                    variant="outlined"
                    id={'backBtn'}
                    sx={{ width: '100%' }}
                    className="receiveitembtn"
                    onKeyDown={(e) => {
                      navigation3(e, isBranchWise ? id.fromDate : id.financialYear, id.reportmainButton, () => {
                        setSearchResult(true)
                        focusElemnt(id.reportmainButton)
                      })
                    }}
                    onClick={() => {
                      setSearchResult(true)
                    }}
                  >
                    Back
                  </Button>
                </Box>
              </>
            )}
          </Item>
        </Item>
      </Stack>
      {searchResult ? (
        <>
          <Stack
            sx={{ marginLeft: 2, marginRight: 2, paddingTop: '0px', paddingBottom: '16px', overflowX: 'scroll' }}
            className="userwise-collection-table"
          >
            <VirtualizedTable
              tableData={showTableData}
              headerContent={headerContent}
              rowContent={bodyContent}
              tableStyle={{ tableLayout: 'auto', width: '100%' }}
              autoResize={true}
            />
          </Stack>
        </>
      ) : (
        <>
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <object
              id="userWiseCollectionoutput"
              type="application/pdf"
              width={'100%'}
              height="440"
              title="MTLPL -Cargo System - After Transfer Summary Report"
              aria-label="MTLPL -Cargo System - After Transfer Summary Report"
            ></object>
          ) : (
            ''
          )}
        </>
      )}
    </>
  )
}
